"use client"
import { useEffect, useRef, useState } from "react"

export type BlockSize = {
  width: number
  height: number
}

const getElementBlockSize = (element: HTMLDivElement): BlockSize => {
  const rect = element.getBoundingClientRect()
  return { width: rect.width, height: rect.height }
}

const hasUsableBlockSize = (size: BlockSize): boolean => (
  size.width > 0 && size.height > 0
)

const isSameBlockSize = (first: BlockSize, second: BlockSize): boolean => (
  first.width === second.width && first.height === second.height
)

// Measures the actual treemap box so cell layout follows responsive CSS width.
export const useMeasuredPowerBlock = (initialSize: BlockSize) => {
  const blockRef = useRef<HTMLDivElement | null>(null)
  const [blockSize, setBlockSize] = useState<BlockSize>(initialSize)

  useEffect(() => {
    const element = blockRef.current
    if (!element) return
    const updateBlockSize = () => {
      const nextSize = getElementBlockSize(element)
      if (!hasUsableBlockSize(nextSize)) return
      setBlockSize(previousSize => (
        isSameBlockSize(previousSize, nextSize) ? previousSize : nextSize
      ))
    }
    updateBlockSize()
    const resizeObserver = new ResizeObserver(updateBlockSize)
    resizeObserver.observe(element)
    return () => resizeObserver.disconnect()
  }, [])

  return { blockRef, blockSize }
}
